import styled from 'styled-components'

import { theme } from '../../../theme'

const FormLabelBase = styled.label`
  font-family: ${theme.fonts.mainFont};
  color: ${theme.colors.sapphireDark};
  display: block;
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  min-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const FormLabel = styled(FormLabelBase)`
  margin-bottom: 8px;
  font-weight: 500;
`

export const FormLabelHoverState = styled(FormLabelBase)`
  color: ${theme.colors.second};
  font-weight: 400;
  &:hover {
    color: ${theme.colors.sapphireDark};
  }
`
